module.exports = {
    init: function () {

        (function($){
            let bounceRecorded = false;
            function createCookie(name, value, hours) {
                if (hours) {
                    var date = new Date();
                    date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
                    var expires = "; expires=" + date.toGMTString();
                } else var expires = "";
                document.cookie = name + "=" + value + expires + "; path=/";
            }

            function readCookie(name) {
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
                }
                return null;
            }


            if(readCookie('fpBounceFired')) {return; }


            $('#fp-bounce-ads .fp-bounce-ad-article').click(function(){
                if(window.ga){
                ga('send', 'event', 'Exit Popup', 'click on popup content recommendation', undefined, undefined, {nonInteraction: true});
                }
            });


            let bouncePopup = $('#fp_bounce_popup');

            $('#fp-bounce-header-close', bouncePopup).click(function(event) {
                event.stopPropagation();
                event.preventDefault();

                $('#fp-bounce-unit', bouncePopup).addClass('fp-bounce-spring-loaded');

                setTimeout(function () {
                    bouncePopup.hide();
                }, 400);
            });

            let openBouncePopup = function() {
                if(bounceRecorded || readCookie('fpBounceFired'))
                    return;

                bounceRecorded = true;

                let recommendationItemsSelector = '#fp-bounce-ads .fp-bounce-ad-article';

                createCookie('fpBounceFired', 1, 1);

                $(recommendationItemsSelector, bouncePopup).addClass('fp-bounce-spring-loaded');

                bouncePopup.show();

                if(window.ga){
                    ga('send', 'event', 'Exit Popup', 'popup fired', undefined, undefined, {nonInteraction: true});
                }

                $('#fp-bounce-unit', bouncePopup).removeClass('fp-bounce-spring-loaded');

                $(recommendationItemsSelector, bouncePopup).each(function(index) {
                    var self = this;
                    setTimeout(function () {
                        $(self).removeClass('fp-bounce-spring-loaded');
                    }, index * 100);
                });

            };

            $('html').on('mouseleave', openBouncePopup);

        }((window.jQuery)));

    }
};


// WEBPACK FOOTER //
// ./assets/src/js/exit-popup.js